import CustomerStoryHorizontal from "@components/BasicComponents/Cards/CustomerStory/CustomerStoryHorizontal"
import SwiperT from "@components/BasicComponents/Swiper/MySwiper"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import {useLocale} from "@components/Contexts/LocaleContext"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonComponent from "@components/Theme/Button/Button"
import ButtonContainer from "@components/WebsiteRevamp/ButtonContainer/ButtonContainer"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetModuleType,
	CustomerStoryModuleType,
	LogosModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import {useRouter} from "next/router"
import React from "react"
import Marquee from "react-fast-marquee"
import {SwiperSlide} from "swiper/react"

import styles from "./HomeCustomersSection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
	stories: CustomerStoryModuleType[]
	logos: LogosModuleType[]
}
const HomeCustomersSection = (props: Props) => {
	const {locale} = useLocale()
	const router = useRouter()

	const desiredSlugs = [
		"communicating-in-the-midst-of-geopolitical-turbulences",
		"setrab-improves-operational-efficiency-and-standardises-training-with-dream-broker-studio",
		"transforming-vocational-education-at-luksia-with-dream-broker-studio",
	]

	const matchedStories = desiredSlugs
		.map((slug) => props.stories.find((story) => story.slug === slug))
		.filter(Boolean) as CustomerStoryModuleType[]

	const matchedSlugs = new Set(matchedStories.map((story) => story.slug))
	const additionalStories = props.stories.filter(
		(story) => !matchedSlugs.has(story.slug),
	)

	const finalStories = [...matchedStories, ...additionalStories].slice(0, 3)

	/*
	Filter case for Swedish language becaseu CMS show Swedish language as "sv-SE"
	But website takes only "se" as Swedish.
	Potentially in the future for Norway case as well, perhaps creating a helper function.

	Same case in LogoSlider.tsx
	*/
	const isCurrentLocaleSwedish = (router.locale || locale) === "se"

	const logosFiltered = isCurrentLocaleSwedish
		? props.logos.filter((logo) => logo.lang === "se")
		: props.logos.filter((logo) => logo.lang === locale)

	return (
		<Separator size={128}>
			<ContainerWrapper className={styles.container}>
				<Typography
					content={props.data.sectionTitle}
					variant={Variant.SectionTitle}
				/>
				<Separator />
				<SwiperT
					className={"SwiperCustomer"}
					module={finalStories.map((element, index) => (
						<SwiperSlide key={index}>
							<CustomerStoryHorizontal
								className={styles.cardContainer}
								data={element}
							/>
						</SwiperSlide>
					))}
					spaceBetween={300}
				/>
				<Separator />

				<Marquee className={styles.logosBox} speed={100} pauseOnHover>
					{logosFiltered.map(
						(element: LogosModuleType, index: number) => (
							<NewResponsiveImage
								key={index}
								imageClassName={styles.image}
								withoutContainer
								{...element.logo}
								alt={element?.title}
							/>
						),
					)}
				</Marquee>
				<Separator size={64} />
				<ButtonContainer>
					<ButtonComponent
						buttonType={"secondary"}
						link={props.data.sectionBottomButtonLink}
						size={"large"}
						asLink
					>
						{props.data.sectionBottomButton}
					</ButtonComponent>
				</ButtonContainer>
			</ContainerWrapper>
		</Separator>
	)
}

export default HomeCustomersSection
